const LETTER = `[A-Za-zÀ-ÖØ-öø-ÿ']`
export const nomeSobrenomeRegExp = new RegExp(
  String.raw`^(?=.{1,100}$)(?:${LETTER}{2,}(?:\s${LETTER}+)*\s${LETTER}{2,}$|${LETTER}{2,}(?:\s${LETTER}+){2,}$)`,
)

export const regexParaCodigoProduto = new RegExp(/\[([^\]\r\n]{1,25})]/)
